import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { gql } from "graphql-tag";
import { InterestRemovalReason, InterestRemovalReasonVariables, requestReinstatement as requestReinstatementType, requestReinstatementVariables } from "types/gql-types";

import ReinstateModal from "./reinstate-modal";

const REQUEST_REINSTATEMENT = gql`
  mutation requestReinstatement(
    $interestId: ID!, $reason: String!, $other: String, $details: String) {
    requestReinstatement(interestId: $interestId, reason: $reason, other: $other, details: $details)
  }
`;

const INTEREST_REMOVAL_REASON = gql`
  query InterestRemovalReason($interestId: ID!) {
    interestRemovalReason(interestId: $interestId)
  }
`;

export type ReinstateModalLoaderProps = {
  isOpen: boolean;
  onRequestClose: (isRemoved: boolean) => void;
  interestId: string;
  interestListName: string;
  waitlistCode?: string;
  removalDate: string;
  reinstatementDays: number;
}
const ReinstateModalLoader: React.FC<ReinstateModalLoaderProps> = (props) => {

  const query =
  useQuery<InterestRemovalReason, InterestRemovalReasonVariables>(INTEREST_REMOVAL_REASON, {
    variables: { interestId: props.interestId },
  });

  const [requestReinstatement, { loading }] =
    useMutation<requestReinstatementType, requestReinstatementVariables>(REQUEST_REINSTATEMENT);

  return <ReinstateModal
    {...props}
    interestRemovalReason={query.data?.interestRemovalReason || ""}
    requestReinstatement={requestReinstatement}
    loading={loading}
  />;
};

export default ReinstateModalLoader;
